// Early/late clock variance (same 15-min grace as the server and the mobile app, mobile/src/utils/shiftTime.ts).
// Clocking in more than the grace before/after the scheduled start, or clocking out more than the grace after the
// scheduled end, needs a stated reason; every clock-in/out screen sends it as `varianceReason` and the server stores it.
export const CLOCK_VARIANCE_GRACE_MIN = 15;

const at = (date, time) => {
  if (!date || !/^\d{1,2}:\d{2}/.test(time || '')) return null;
  const ms = new Date(`${date}T${time.length === 4 ? `0${time}` : time.slice(0, 5)}`).getTime();
  return Number.isFinite(ms) ? ms : null;
};
const startMs = (s) => at(s?.date, s?.start_time);
const endMs = (s) => {
  const ms = at(s?.end_date || s?.date, s?.end_time);
  if (ms === null) return null;
  const st = startMs(s);
  return !s?.end_date && st !== null && ms <= st ? ms + 86400000 : ms;   // overnight shift ends the next day
};

const variance = (ref, now, grace) => {
  if (ref === null) return null;
  const delta = Math.round(((typeof now === 'number' ? now : now.getTime()) - ref) / 60000);
  if (delta > grace) return { kind: 'late', minutes: delta };
  if (delta < -grace) return { kind: 'early', minutes: -delta };
  return null;
};

/** { kind: 'early' | 'late', minutes } vs the scheduled start beyond the grace window, else null. */
export const clockInVariance = (s, now = Date.now(), grace = CLOCK_VARIANCE_GRACE_MIN) => variance(startMs(s), now, grace);

/** { kind: 'late', minutes } past the scheduled end beyond the grace window, else null (as the server flags over_check_out). */
export const clockOutVariance = (s, now = Date.now(), grace = CLOCK_VARIANCE_GRACE_MIN) => {
  const v = variance(endMs(s), now, grace);
  return v && v.kind === 'late' ? v : null;
};

/** Label + placeholder for the reason box ('in' | 'out'). */
export function clockVarianceText(action, v) {
  if (action === 'in') {
    return v.kind === 'early'
      ? { label: `Early clock-in reason — ${v.minutes} min before start (required)`, placeholder: 'Why are you starting early?' }
      : { label: `Late clock-in reason — ${v.minutes} min after start (required)`, placeholder: 'Why are you starting late?' };
  }
  return { label: `Late clock-out reason — ${v.minutes} min after end (required)`, placeholder: 'Why are you finishing later than the scheduled end?' };
}
